export const es: Record<string, string> = {

  // ── Breadcrumb ──
  'Dashboard': 'Panel de control',
  'Profile': 'Perfil',

  // ── Tab Labels ──
  'Personal Details': 'Datos personales',
  'Demographics': 'Datos demográficos',
  'Medical History': 'Historial médico',
  'Insurance Information': 'Información de seguro',
  'Documents': 'Documentos',
  'Settings': 'Configuración',

  // ── Personal Details Tab ──
  'Mahi': 'Mahi',

  'Manage your basic details, contact information, and emergency contacts using the sections below.': 'Administre sus datos básicos, información de contacto y contactos de emergencia en las secciones a continuación.',
  'Profile Photo': 'Foto de perfil',
  'Basic Details': 'Datos básicos',
  'First Name': 'Nombre',
  'Last Name': 'Apellido',
  'Date of Birth': 'Fecha de nacimiento',
  'Address': 'Dirección',
  'City': 'Ciudad',
  'State': 'Estado',
  'ZIP Code': 'Código postal',
  'Country': 'País',
  'Care Team': 'Equipo de atención',
  'Internal Co-manager': 'Co-gestor interno',
  'External Co-manager': 'Co-gestor externo',
  'Primary Care Physician': 'Médico de atención primaria',
  'Referral': 'Derivación',
  'Contact Information': 'Información de contacto',
  'Email': 'Correo electrónico',
  'Mobile Number': 'Número de móvil',
  'Emergency Contact Information': 'Contacto de emergencia',
  'Name': 'Nombre',
  'Relation': 'Parentesco',
  'Communication Preference': 'Preferencia de comunicación',
  'SMS': 'SMS',

  // ── Demographics Tab ──
  'Demographics & Personal Background': 'Datos demográficos y perfil personal',
  'Review and update your personal information, language preferences, and identity details to help us provide better care.': 'Revise y actualice su información personal, preferencias de idioma y datos de identidad para ayudarnos a brindarle una mejor atención.',
  'Details': 'Detalles',
  'Ethnicity': 'Etnicidad',
  'Race': 'Origen racial',
  'Preferred Language': 'Idioma preferido',
  'Expressions': 'Expresiones',
  'Proficiency': 'Nivel de dominio',
  'Sexual Orientation': 'Orientación sexual',
  'Gender Identity': 'Identidad de género',
  'Multiple Births': 'Nacimientos múltiples',

  // ── Medical History Tab ──
  'Review your medical history summary here, and click the Edit button to update any details.': 'Revise el resumen de su historial médico aquí y haga clic en el botón Editar para actualizar cualquier dato.',
  'Medical Conditions': 'Condiciones médicas',
  'Lifestyle Factors': 'Factores del estilo de vida',
  'Alcohol Consumption': 'Consumo de alcohol',
  'Smoking': 'Tabaquismo',
  'Drugs Use': 'Consumo de drogas',
  'Current Medications': 'Medicamentos actuales',
  'Allergies': 'Alergias',
  'Is there anything else we should know?': '¿Hay algo más que debamos saber?',
  'Monitor for any signs of allergic reaction, and administer antihistamines as needed.': 'Monitoree cualquier signo de reacción alérgica y administre antihistamínicos según sea necesario.',

  // ── Insurance Tab ──
  'Review and manage your insurance coverage details': 'Revise y administre los detalles de su cobertura de seguro',
  'Coverage Type': 'Tipo de cobertura',
  'Payor': 'Pagador',
  'Plan': 'Plan',
  'Policy Holder': 'Titular de la póliza',
  'Policy ID': 'Número de póliza',
  'Group ID': 'Número de grupo',
  'Effective Date': 'Fecha de vigencia',
  'Expiry Date': 'Fecha de vencimiento',
  'Insurance Card Images': 'Imágenes de la tarjeta de seguro',

  // ── Documents Tab ──
  'Files & Records': 'Archivos y registros',
  'Download, review, or update your documents.': 'Descargue, revise o actualice sus documentos.',
  'Action': 'Acción',
  'No documents found': 'No se encontraron documentos',
  'Download': 'Descargar',
  'Delete': 'Eliminar',

  // ── Settings Tab ──
  'Account & Preferences': 'Cuenta y preferencias',
  'Manage your account details, security settings, and communication preferences.': 'Administre los detalles de su cuenta, la configuración de seguridad y las preferencias de comunicación.',
  'Account': 'Cuenta',
  'Change Password': 'Cambiar contraseña',
  'Login Activity': 'Actividad de inicio de sesión',
  'Preferences': 'Preferencias',
  'Language': 'Idioma',

  // ── Change Password Modal ──
  'Current Password': 'Contraseña actual',
  'Enter current password': 'Ingrese la contraseña actual',
  'Current password is required.': 'La contraseña actual es obligatoria.',
  'Password must be at least 8 characters.': 'La contraseña debe tener al menos 8 caracteres.',
  'New Password': 'Nueva contraseña',
  'Enter new password': 'Ingrese la nueva contraseña',
  'New password is required.': 'La nueva contraseña es obligatoria.',
  'Confirm New Password': 'Confirmar nueva contraseña',
  'Re-enter new password': 'Vuelva a ingresar la nueva contraseña',
  'Please confirm your new password.': 'Por favor confirme su nueva contraseña.',
  'Passwords do not match.': 'Las contraseñas no coinciden.',
  'Cancel': 'Cancelar',
  'Save Changes': 'Guardar cambios',

  // ── Login Activity Modal ──
  'Current': 'Actual',
  'Sign Out': 'Cerrar sesión',
  'Sign Out of Other Devices': 'Cerrar sesión en otros dispositivos',

  // ── Unsaved Changes Modal ──
  'Unsaved Changes': 'Cambios no guardados',
  'You have unsaved changes. If you switch tabs, your edits won\'t be saved. Do you still want to proceed?': 'Tiene cambios no guardados. Si cambia de pestaña, sus ediciones no se guardarán. ¿Desea continuar de todas formas?',
  'No': 'No',
  'Yes': 'Sí',


























  'Prescriptions': 'Recetas médicas',
  'View your active medications and download your prescriptions.': 'Vea sus medicamentos activos y descargue sus recetas médicas.',

  // ── Left Panel ──
  'Prescription List': 'Lista de recetas',

  // ── Right Panel ──
  'Download Prescription': 'Descargar receta',

  // ── Medication Summary ──
  'Medications Prescribed': 'Medicamentos prescritos',

  // ── Medication Details ──
  'Duration:': 'Duración:',
  'Quantity': 'Cantidad',
  'Days Supply': 'Días de suministro',
  'Refills Left': 'Recargas restantes',
  'Prescribed By': 'Prescrito por',
  'Medication Instructions': 'Instrucciones del medicamento',

  // ── Empty State ──
  'No Prescriptions prescribed': 'No hay recetas prescritas',

  // ── Mobile ──
  'View Details': 'Ver detalles',

  // ── Refill Modal ──
  'Request medication refill?': '¿Solicitar recarga de medicamento?',
  'This request will be sent to your care team for review. You\'ll be notified once it\'s processed.': 'Esta solicitud será enviada a su equipo de atención para revisión. Se le notificará una vez que sea procesada.',


  // ── Toast ──
  'Your request has been sent!': '¡Su solicitud ha sido enviada!',

  // ── Need Help Offcanvas ──
  'Need Help?': '¿Necesita ayuda?',
  'We are here to assist you': 'Estamos aquí para ayudarle',
  'Our support team is available': 'Nuestro equipo de soporte está disponible',
  'Monday - Friday, 8:00 AM': 'Lunes - Viernes, 8:00 AM',
  'to': 'a',
  '6:00 PM': '6:00 PM',
  'EST. Call or text us for assistance with your profile, appointments, or any questions.': 'EST. Llámenos o envíenos un mensaje para obtener ayuda con su perfil, citas o cualquier pregunta.',
  'Call': 'Llamar',




















  'My Visits': 'Mis consultas',
  'Forms': 'Formularios',
  'Activity Logs': 'Registros de actividad',
  'Education Library': 'Biblioteca educativa',
  'Logout Account': 'Cerrar sesión',

  // ── Desktop Header ──
  'Clinic Support:': 'Soporte clínico:',
























  'My Onboarding Forms': 'Mis formularios de incorporación',
  'Start a new form or continue with your pending ones.': 'Comience un nuevo formulario o continúe con los pendientes.',

  // ── Table Headers ──
  'S.No': 'N.°',
  'Doctor Name': 'Nombre del médico',
  'Appointment Date & Time': 'Fecha y hora de la cita',
  'Status': 'Estado',
  'Actions': 'Acciones',

  // ── Section Headings ──
  'Upcoming Appointments': 'Próximas citas',
  'Previous Appointments': 'Citas anteriores',

  // ── Status Labels ──
  'New': 'Nuevo',
  'Pending': 'Pendiente',
  'Submitted': 'Enviado',
  'Reviewed': 'Revisado',

  // ── Action Buttons ──
  'Start Onboarding Form': 'Iniciar formulario de incorporación',
  'Continue Filling Form': 'Continuar llenando el formulario',
  'View/Edit Form': 'Ver / Editar formulario',
  'View Form': 'Ver formulario',

  // ── Empty State ──
  'No Upcoming Appointments': 'No hay próximas citas',
  'You have no scheduled or appointments.': 'No tiene citas programadas.',

  // ── Onboarding Offcanvas ──
  'Onboarding Summary': 'Resumen de incorporación',
  'Review your details. Click \'Edit the form\' to update the information.': 'Revise sus datos. Haga clic en « Editar el formulario » para actualizar la información.',
  'Edit the form': 'Editar el formulario',



































   // ── Education Library Page ──
  'Education Video Library': 'Biblioteca de videos educativos',
  'Learn about your eye health and upcoming procedures.': 'Infórmese sobre la salud de sus ojos y los procedimientos próximos.',

  'Ordered By': 'Ordenado por',
  'Sent On': 'Enviado el',
  'Procedure': 'Procedimiento',

  // ── Education Library Actions ──
  'Watch': 'Ver',
  'View Image': 'Ver imagen',
  'View PDF': 'Ver PDF',
  'Play Video': 'Reproducir video',
  'Open Document': 'Abrir documento',

  // ── Education Library Empty State ──
  'No documents available': 'No hay documentos disponibles',

  // ── Dashboard Header ──
  'Welcome': 'Bienvenido/a',
  'Documents shared by your care team': 'Documentos compartidos por su equipo de atención',
  'Manage your visits, bills, and health information in one place.': 'Gestione sus consultas, facturas e información de salud en un solo lugar.',

  // ── Dashboard Quick Actions (Mobile) ──
  'Book Appt': 'Reservar cita',
  'Bill Pay': 'Pagar factura',
  'Insurance': 'Seguro',

  // ── Dashboard Quick Actions (Desktop) ──
  'Book Appointment': 'Reservar una cita',

  'View All Forms': 'Ver todos los formularios',
  'at': 'a las',
  'Reschedule Requested': 'Reprogramación solicitada',
  'Rescheduled': 'Reprogramado',
  'Completed': 'Completado',
  'Cancelled': 'Cancelado',
  'Fill Onboarding Form': 'Completar formulario de incorporación',
  'Continue Filling Onboarding form': 'Continuar llenando el formulario de incorporación',

  // ── Dashboard Carousel Slides ──
  'Buy One, Get One on Contact Lenses': 'Lleve dos lentes de contacto al precio de uno',
  'Stock up and save on your vision needs.': 'Abastézcase y ahorre en sus necesidades visuales.',
  '20% Off Eyeglasses': '20 % de descuento en anteojos',
  'Trendy frames for every face.': 'Monturas de moda para cada rostro.',
  'Free Eye Checkup': 'Revisión ocular gratuita',
  'Limited time offer with purchases.': 'Oferta por tiempo limitado con cualquier compra.',

  // ── Dashboard Billing ──
  'Billing Status': 'Estado de facturación',
  'Outstanding Balance': 'Saldo pendiente',
  'Pay Now': 'Pagar ahora',
  'View Statement': 'Ver estado de cuenta',
  'Billing not started yet': 'Facturación aún no iniciada',
  'No outstanding balance. Your account is in good standing.': 'Sin saldo pendiente. Su cuenta está al corriente.',

  // ── Dashboard Vision ──
  'Vision Summary': 'Resumen de visión',
  'Last Vision Values': 'Últimos valores visuales',
  'Right Eye': 'Ojo derecho',
  'Left Eye': 'Ojo izquierdo',
  'Glass Prescription': 'Receta de lentes',
  'SPH': 'ESF',
  'CYL': 'CIL',
  'AXIS': 'EJE',
  'No vision data on file': 'No hay datos visuales registrados',
  'Complete your first eye exam to see your vision summary here.': 'Complete su primer examen de la vista para ver su resumen visual aquí.',

  // ── Dashboard Reminders ──
  'Reminders & Alerts': 'Recordatorios y alertas',
  'Remind me': 'Recordarme',
  'No Alerts!': '¡Sin alertas!',

  // ── Dashboard Recent Visits ──
  'Recent Visits': 'Consultas recientes',
  'View All Visits': 'Ver todas las consultas',
  'No visit history yet': 'Aún no hay historial de consultas',
  'Your past appointments and visit records will appear here.': 'Sus citas pasadas y registros de consultas aparecerán aquí.',
  'No Show': 'No se presentó',

  'Book an appointment with your optometrist to get started.': 'Reserve una cita con su optometrista para comenzar.',

  'View Library': 'Ver biblioteca',

  'Patient has no insurances': 'El paciente no tiene seguros',
  'Support Phone Number': 'Número de teléfono de soporte',

  // ── Reschedule Popovers ──
  'Reschedule Remarks': 'Comentarios sobre la reprogramación',
  'Reschedule Details': 'Detalles de la reprogramación',
  'New Appointment': 'Nueva cita',
  'This appointment is rescheduled to': 'Esta cita ha sido reprogramada para el',
  'Reason:': 'Motivo:',

  // ── Card Payment Modal ──
  'Card Payment': 'Pago con tarjeta',

  'A record of what you viewed, downloaded, or changed': 'Un registro de lo que consultó, descargó o modificó',
  'Filter': 'Filtrar',

  // ── Activity Logs Filter Form ──
  'From Date': 'Fecha de inicio',
  'To Date': 'Fecha de fin',
  'Log Type': 'Tipo de registro',
  'Search': 'Buscar',
  'Select All': 'Seleccionar todo',
  'Date': 'Fecha',
  'Time': 'Hora',
  'Description': 'Descripción',

  // ── Activity Log Type Badges ──
  'Accessed': 'Consultado',
  'Exported': 'Exportado',
  'Transmitted': 'Transmitido',
  'Downloaded': 'Descargado',
  'Added': 'Agregado',
  'Deleted': 'Eliminado',
  'Edited': 'Editado',
  'Login': 'Inicio de sesión',
  'Logout': 'Cierre de sesión',

  // ── Activity Logs Pagination ──
  'Back': 'Anterior',
  'Next': 'Siguiente',
  'Previous': 'Anterior',

  // ── Activity Logs Mobile Filter ──
  'Date Range': 'Rango de fechas',
  'From': 'Desde',
  'To': 'Hasta',
  'Reset': 'Restablecer',
  'Apply Filters': 'Aplicar filtros',


























  'Review your health summaries, download official case sheets, and share them anytime.':
    'Revisa tus resúmenes de salud, descarga hojas de caso oficiales y compártelas en cualquier momento.',
  'Download Visit Summary': 'Descargar Resumen de Visita',

  // Appointment Sections
  'Current Appointments': 'Citas Actuales',

  // Appointment Details
  'Provider': 'Proveedor',
  'Surgery': 'Cirugía',
  'Location': 'Ubicación',

  // Status Labels
  'Confirmed': 'Confirmado',
  'Not Confirmed': 'No Confirmado',
  'Active': 'Activo',
  'InActive': 'Inactivo',

  // Dropdown Actions
  'View visit summary': 'Ver resumen de visita',
  'Export visit summary': 'Exportar resumen de visita',
  'View summary': 'Ver resumen',
  'View technical data (CCDA format)': 'Ver datos técnicos (formato CCDA)',
  'Share via email': 'Compartir por correo',
  'Send Reschedule Request': 'Enviar solicitud de reprogramación',
  'FG Rx Print': 'Imprimir FG Rx',

  // No Data
  'No Appointments Found': 'No Se Encontraron Citas',
  'You have no scheduled or past appointments.':
    'No tiene citas programadas o anteriores.',

  // Mobile View
  'Show details': 'Mostrar detalles',

  // Download Visit Summary Popup
  'Download Visit Summary Title': 'Descargar Resumen de Visita',
  'Provider Name': 'Nombre del Proveedor',
  'Appt. Date': 'Fecha de Cita',
  'Visit Reason': 'Motivo de Visita',
  'Last Exported By': 'Último Exportado Por',
  'Last Export Date': 'Fecha de Última Exportación',
  'No Data Found': 'No Se Encontraron Datos',

  // Consultation Summary Popup
  'Consultation Summary': 'Resumen de Consulta',
  'Download Button': 'Descargar',
  'Chief Complaints': 'Quejas Principales',
  'Review of Systems': 'Revisión de Sistemas',
  'Ocular History': 'Historia Ocular',
  'Ocular Surgical History': 'Historia Quirúrgica Ocular',
  'Current Eye Medication': 'Medicación Ocular Actual',
  'Past Medical History': 'Historia Médica Pasada',
  'Surgical History': 'Historia Quirúrgica',
  'Current Systemic Medication': 'Medicación Sistémica Actual',
  'Family History': 'Historia Familiar',
  'Functional Status': 'Estado Funcional',
  'Menstrual History': 'Historia Menstrual',
  'Vaccination History': 'Historia de Vacunación',
  'Birth History': 'Historia de Nacimiento',
  'Nutritional History': 'Historia Nutricional',
  'Physical Evaluation': 'Evaluación Física',
  'Implants': 'Implantes',
  'Psychological Observations': 'Observaciones Psicológicas',
  'Lifestyle History': 'Historia de Estilo de Vida',
  'Psychiatry': 'Psiquiatría',
  'Health Concerns & Goals': 'Preocupaciones y Metas de Salud',
  'Lab & Investigation': 'Laboratorio e Investigación',
  'Vitals': 'Signos Vitales',
  'Fall Risk Assessment': 'Evaluación de Riesgo de Caídas',

  // Table Headers - Review of Systems
  'Medical Condition': 'Condición Médica',
  'Sub Relation': 'Sub Relación',
  'Age': 'Edad',
  'Concern Expressed by': 'Preocupación Expresada Por',
  'Goals Expressed by': 'Metas Expresadas Por',
  'Onset': 'Inicio',
  'Start Date': 'Fecha de Inicio',
  'End Date': 'Fecha de Fin',
  'Result Value': 'Valor del Resultado',
  'Medicine & ROA': 'Medicamento y Vía de Administración',
  'Refills': 'Recargas',
  'Vaccine & Manufacturer': 'Vacuna y Fabricante',
  'Dosage': 'Dosis',
  'Habit': 'Hábito',
  'Consumption': 'Consumo',
  'Assessment Criteria': 'Criterios de Evaluación',
  'Response': 'Respuesta',
  'Score': 'Puntuación',

  // Vitals
  'Temperature': 'Temperatura',
  'Pulse': 'Pulso',
  'BP-Systolic': 'PA-Sistólica',
  'BP-Diastolic': 'PA-Diastólica',
  'Resp. Rate': 'Frecuencia Respiratoria',
  'SpO2': 'SpO2',
  'Inh. O2 Conc.': 'Conc. O2 Inhalado',
  'BGL': 'Glucemia',
  'HOFC Perc.': 'Perc. HOFC',
  'Weight': 'Peso',
  'Height': 'Talla',
  'BMI': 'IMC',
  'Heart Rate': 'Frecuencia Cardíaca',

  // Dilation
  'Dilation': 'Dilatación',
  'Eye': 'Ojo',
  'Drops': 'Gotas',
  'Frequency': 'Frecuencia',
  'Start Time': 'Hora de Inicio',
  'Notes': 'Notas',
  'No, Dilation has not been performed for this visit':
    'No, no se realizó dilatación en esta visita',

  // Vision and Perception
  'Vision and Perception': 'Visión y Percepción',
  'Visual Acuity': 'Agudeza Visual',
  'Auto Refraction': 'Auto Refracción',
  'Retinoscopy': 'Retinoscopia',
  'Present Glass Rx': 'Receta de Lentes Actual',
  'Manifest Refraction': 'Refracción Manifiesta',
  'Final Glass Rx': 'Receta Final de Lentes',
  'Cycloplegic Refraction': 'Refracción Ciclopléjica',
  'Over Refraction': 'Sobre Refracción',
  'Pachymetry': 'Paquimetría',
  'IOP (Tonometry)': 'PIO (Tonometría)',
  'Pupil Size': 'Tamaño de Pupila',
  'PAM (Potential Acuity Meter)': 'PAM (Medidor de Agudeza Potencial)',
  'Keretometry': 'Queratometría',
  'Glare': 'Deslumbramiento',

  // Vision Table Headers
  'SC-(D)': 'SC-(D)',
  'SC-(N)': 'SC-(N)',
  'CC-(GL)(D)': 'CC-(GL)(D)',
  'CC-(GL)(N)': 'CC-(GL)(N)',
  'CC-(CL)(D)': 'CC-(CL)(D)',
  'CC-(CL)(N)': 'CC-(CL)(N)',
  'Pinhole(D)': 'Estenopeico(D)',
  'TAC(D)': 'TAC(D)',
  'Sph': 'Esf',
  'Cyl': 'Cil',
  'Axis': 'Eje',
  'Add': 'Adición',
  'Prism': 'Prisma',
  'Type': 'Tipo',
  'Duo': 'Duo',
  'Cs': 'Cs',
  'VA (D)': 'AV (L)',
  'VA (N)': 'AV (C)',
  'VA (I)': 'AV (I)',

  // Pachymetry Table
  'H Axis': 'Eje H',
  'V Axis': 'Eje V',
  'Avg. K Value': 'Valor K Prom.',
  'Cyl Value': 'Valor Cil',
  'Average': 'Promedio',
  'Given by': 'Dado Por',
  'Device': 'Dispositivo',
  'OD CC': 'OD CC',
  'OS CC': 'OS CC',

  // Contact Lens
  'Contact Lens - Soft Contact Lens': 'Lente de Contacto - Lente Blando',
  'RGP ( Rigid Gas Permeable )': 'RGP (Rígido Gas Permeable)',
  'Wearing': 'Uso',
  'Trail': 'Prueba',
  'Final': 'Final',
  'Dispensed Trial': 'Prueba Dispensada',
  'Manufacturer': 'Fabricante',
  'Series': 'Serie',
  'BC': 'RC',
  'Diameter': 'Diámetro',
  'Colour': 'Color',
  'Rx Expiration': 'Vencimiento de Receta',
  'Replacement Schedule': 'Programa de Reemplazo',
  'Wearing Instruction': 'Instrucción de Uso',
  'Advance': 'Avanzado',
  'Fit': 'Adaptación',
  'Comfort': 'Confort',
  'Centration': 'Centrado',
  'Coverage': 'Cobertura',
  'Movement': 'Movimiento',
  'Degree': 'Grado',
  'Direction': 'Dirección',
  'Added by': 'Agregado Por',

  // Examination
  'Examination': 'Examen',
  'Anterior Segment': 'Segmento Anterior',
  'Posterior Segment': 'Segmento Posterior',
  'Gonioscopy': 'Gonioscopía',
  'Motor Examinations': 'Exámenes Motores',
  'Extra Ocular Motility': 'Motilidad Extraocular',
  'Ductions': 'Ducciones',
  '9 Gaze Evaluation': 'Evaluación de 9 Posiciones de Mirada',
  'Squint Evaluation': 'Evaluación de Estrabismo',
  'Cover/Alternate Cover Test': 'Test de Oclusión / Oclusión Alternante',
  'Corneal Reflex / HCRT': 'Reflejo Corneal / HCRT',
  'Prism Cover / Alternate Cover Test': 'Test de Prisma y Oclusión / Alternante',
  'Nystagmus': 'Nistagmo',
  'Head Posture': 'Postura de la Cabeza',
  'Binocular Vision Test': 'Test de Visión Binocular',
  'Worth Four Dot Test': 'Test de los Cuatro Puntos de Worth',
  'Near Point Convergence': 'Punto Próximo de Convergencia',
  'Fusional Vergence': 'Vergencia Fusional',
  'Near Point Accomodation': 'Punto Próximo de Acomodación',
  'Stereopsis': 'Estereopsis',
  'Additional Examinations': 'Exámenes Adicionales',
  'Dry Eye Evaluation': 'Evaluación de Ojo Seco',
  'Color Vision Test': 'Test de Visión de Color',
  'Lacrimal Patency': 'Permeabilidad Lacrimal',
  'Amsler Grid': 'Cuadrícula de Amsler',
  '4 Field Test': 'Test de 4 Campos',
  '8 Field Test': 'Test de 8 Campos',

  // Assessments
  'Assessments': 'Evaluaciones',
  'Site': 'Sitio',
  'Priority': 'Prioridad',
  'Severity & Status': 'Gravedad y Estado',
  'Plan Of Discussions': 'Plan de Discusiones',
  'Patient Instructions': 'Instrucciones al Paciente',
  'Doctor Notes': 'Notas del Médico',
  'Other Actions Taken': 'Otras Acciones Tomadas',
  'Investigations': 'Investigaciones',

  // Orders
  'Orders': 'Órdenes',
  'Investigation': 'Investigación',
  'Procedure Details': 'Detalles del Procedimiento',
  'Surgery Details': 'Detalles de la Cirugía',
  'Cost Estimated': 'Costo Estimado',
  'Patient Education': 'Educación al Paciente',
  'Return to Office': 'Regreso al Consultorio',

  // Super Bill
  'Super Bill': 'Super Factura',
  'Suggested Procedure': 'Procedimiento Sugerido',
  'Unit': 'Unidad',
  'Modifier': 'Modificador',
  'Additional Diagnosis': 'Diagnóstico Adicional',

  // Medical Rx
  'Medical Rx': 'Receta Médica',
  'Medicine Orders': 'Órdenes de Medicamentos',
  'Glass Rx': 'Receta de Lentes',
  'E Rx Sent': 'Receta Electrónica Enviada',
  'E Rx Pending': 'Receta Electrónica Pendiente',
  'Medication Stopped': 'Medicamento Suspendido',

  // Procedures Section
  'Procedures': 'Procedimientos',
  'Operative Notes': 'Notas Operatorias',
  'Post Op Instructions': 'Instrucciones Post-Operatorias',
  'Complications': 'Complicaciones',
  'Pre Med': 'Pre Medicación',
  'Intra Med': 'Intra Medicación',
  'Post Med': 'Post Medicación',
  'Observations': 'Observaciones',
  'Additional Information': 'Información Adicional',

  // Staff
  'Staff': 'Personal',
  'Scriber': 'Escribiente',
  'Consultation Notes': 'Notas de Consulta',
  'Patient Notes': 'Notas del Paciente',

  // View Summary Popup
  'View Summary': 'Ver Resumen',
  'ASC Download': 'Descargar ASC',
  'Operative Notes Tab': 'Notas Operatorias',
  'Discharge Summary': 'Resumen de Alta',
  'Pre-op Dx': 'Dx Pre-operatorio',
  'Post-op Dx': 'Dx Post-operatorio',
  'Pre-Op Diagnosis': 'Diagnóstico Pre-Operatorio',
  'Post-Op Diagnosis': 'Diagnóstico Post-Operatorio',
  'Procedure (Description)': 'Procedimiento (Descripción)',
  'Anesthesia Type': 'Tipo de Anestesia',
  'Findings': 'Hallazgos',
  'Surgeon Operative Notes': 'Notas Operatorias del Cirujano',
  'Pathology': 'Patología',
  'Code Implants': 'Implantes por Código',
  'Other Codes': 'Otros Códigos',
  'Others Implants': 'Otros Implantes',
  'Post Procedure Note': 'Nota Post Procedimiento',
  'Patients Instructions': 'Instrucciones al Paciente',
  'Post OP Medications': 'Medicamentos Post Operatorios',
  'Medication Orders': 'Órdenes de Medicamentos',
  'Lab/Investigations': 'Laboratorio/Investigaciones',
  'Comments': 'Comentarios',
  'Reviewed By': 'Revisado Por',
  'Signed by': 'Firmado Por',
  'Examinations/Findings': 'Exámenes/Hallazgos',
  'Post Procedures Notes': 'Notas Post Procedimiento',
  'Patient Instructions Discharge': 'Instrucciones al Paciente',
  'Final disposition': 'Disposición Final',
  'Patient Condition on Discharge': 'Condición del Paciente al Alta',
  'Co-Management': 'Co-Manejo',
  'Follow-Up': 'Seguimiento',
  'Signatures': 'Firmas',
  'Patient Name': 'Nombre del Paciente',
  'Nurse Name': 'Nombre de la Enfermera',
  'Accompanied By': 'Acompañado Por',

  // Email Popup
  'Normal Email': 'Correo Normal',
  'PDF Label': 'PDF',
  'To Mail': 'Para',
  'Subject': 'Asunto',
  'Body': 'Cuerpo',
  'Send Request': 'Enviar Solicitud',

  // Reschedule Popup
  'Manage Appointment': 'Gestionar Cita',
  'Please tell us why you\'d like to reschedule or cancel your appointment':
    'Por favor díganos por qué desea reprogramar o cancelar su cita',
  'Enter your reason': 'Ingrese su motivo',
  'Reason is required': 'El motivo es requerido',
  'Please enter a valid email': 'Por favor ingrese un correo válido',
  'Subject is required': 'El asunto es requerido',

  // Export History Popover
  'Export History': 'Historial de Exportación',

  // Common
  'General': 'General',
  'OD': 'OD',
  'OS': 'OS',
  'OU': 'OU',
  'Deferred': 'Diferido',
  'Refused': 'Rechazado',
  'Torch Used': 'Linterna Utilizada',
  'SLE Drawing': 'Dibujo en Lámpara de Hendidura',
  'Fundus Drawing': 'Dibujo de Fondo',
  'Drawing Images': 'Imágenes de Dibujo',
  'Extended Ophthomology': 'Oftalmología Extendida',
  'Lens Used': 'Lente Utilizado',
  'Full And Freely Moving In All Directions': 'Movimiento Completo y Libre en Todas las Direcciones',
  'Limitation of': 'Limitación de',
  'Alphabet Pattern': 'Patrón Alfabético',
  'All Other Indications shows Negative': 'Todas las Otras Indicaciones Muestran Negativo',
  'Patient Indicated': 'Indicado por el Paciente',
  'Electronically Signed By': 'Firmado Electrónicamente Por',
  'Lic': 'Lic',
  'Surgeon': 'Cirujano',
  'Anesthesiologist': 'Anestesiólogo',
  'Nurse': 'Enfermera',
  'Since Birth': 'Desde el Nacimiento',
  'Year(s)': 'Año(s)',
  'Week(s)': 'Semana(s)',
  'Month(s)': 'Mes(es)',
  'Day(s)': 'Día(s)',
  'Hours': 'Horas',
  'Mild': 'Leve',
  'Moderate': 'Moderado',
  'Severe': 'Severo',
  'Provisional': 'Provisional',
  'Resolved': 'Resuelto',
  'RuledOut': 'Descartado',
  'Not Examined': 'No Examinado',
  'Entered In Error': 'Ingresado por Error',
  // ── Common ──
  'N/A': 'N/D',
  // ── Patient Onboarding ──
  'Change language': 'Cambiar idioma',
  'Organization Logo': 'Logotipo de la Organización',
  'Step': 'Paso',
  'of': 'de',
  'Upload Profile': 'Foto de Perfil',
  'Referral letter': 'Carta de Referencia',
  'About you': 'Sobre Usted',
  'Health': 'Salud',
  'Consent': 'Consentimiento',
  'Hi {name}!': '¡Hola {name}!',
  'Save': 'Guardar',
  'Save & Next': 'Guardar y seguir',
  'Save Insurance': 'Guardar Seguro',
  'Back Page': 'Atrás',
  'Previous Consent': 'Anterior',
  'Next Consent': 'Siguiente',
  'Submit': 'Enviar',
  'Remove': 'Eliminar',
  'Capture': 'Capturar',
  'Camera': 'Cámara',
  'Photo Gallery': 'Galería de Fotos',
  'Confirm!': '¡Confirmar!',
  'Take Photo': 'Tomar Foto',
  'Scan your photo ID': 'Escanee su identificación con foto',
  'Line the card up inside the frame. We\'ll read the name, date of birth, ID number and address automatically.': 'Alinee la tarjeta dentro del marco. Leeremos automáticamente el nombre, la fecha de nacimiento, el número de identificación y la dirección.',
  'Tap to scan ID': 'Toque para escanear su identificación',
  'or upload photo of your ID': 'o suba una foto de su identificación',
  '{fields} are detected': 'Se detectaron: {fields}',
  'or enter manually': 'o ingrese los datos manualmente',
  'Enter First Name': 'Ingrese su Nombre',
  'First Name is required': 'El Nombre es obligatorio',
  'Please enter at least one letter in the First Name.': 'Ingrese al menos una letra en el Nombre.',
  'Please enter First Name Minimum 2 letters.': 'El Nombre debe tener al menos 2 letras.',
  'Enter Last Name': 'Ingrese su Apellido',
  'Last Name is required': 'El Apellido es obligatorio',
  'Please enter at least one letter in the Last Name.': 'Ingrese al menos una letra en el Apellido.',
  'Please enter Last Name Minimum 2 letters.': 'El Apellido debe tener al menos 2 letras.',
  'Only Characters Allowed are & , . ( ) / A–Z, 0–9.': 'Solo se permiten los caracteres & , . ( ) / A–Z, 0–9.',
  'mm-dd-yyyy': 'mm-dd-aaaa',
  'Please Enter Date Of Birth': 'Ingrese la Fecha de Nacimiento',
  'Gender': 'Género',
  'Select Gender': 'Seleccionar Género',
  'Please Select Gender': 'Seleccione el Género',
  'Address Line 1': 'Línea de Dirección 1',
  'Enter your Address': 'Ingrese su Dirección',
  'Address cannot exceed 100 characters.': 'La dirección no puede superar los 100 caracteres.',
  'Address Line 2': 'Línea de Dirección 2',
  'Enter Address Line2': 'Ingrese Línea de Dirección 2',
  'Enter City Name': 'Ingrese el Nombre de la Ciudad',
  'Fetching location...': 'Obteniendo ubicación...',
  'Use Current Location': 'Usar Ubicación Actual',
  'Enter Zipcode': 'Ingrese Código Postal',
  'Select Zipcode': 'Seleccionar Código Postal',
  'Enter Email': 'Ingrese su Correo Electrónico',
  'Please enter a valid email address.': 'Ingrese una dirección de correo electrónico válida.',
  'Enter Mobile Number': 'Ingrese el Número de Móvil',
  'Mobile number is required': 'El número de móvil es obligatorio',
  'Mobile Number cannot start with 0 or 1.': 'El número de móvil no puede comenzar con 0 o 1.',
  'Enter a valid 10-digit mobile number.': 'Ingrese un número de móvil válido de 10 dígitos.',
  'Send all future communication, Notices and alerts to :': 'Enviar todas las comunicaciones, avisos y alertas futuras a:',
  '(can select multiple)': '(puede seleccionar varios)',
  'Select': 'Seleccionar',
  'Search...': 'Buscar...',
  '(or)': '(o)',
  'Edit': 'Editar',
  'Close': 'Cerrar',
  'Error': 'Error',
  'Full Name': 'Nombre Completo',
  'Phone Number': 'Número de Teléfono',
  'Relation to you': 'Relación con usted',
  'Select Relation': 'Seleccionar Relación',
  'Self': 'Usted mismo',
  'Patient': 'Paciente',
  'Guardian': 'Tutor',
  'View document': 'Ver documento',
  'Open in new tab': 'Abrir en una nueva pestaña',
  'Profile Picture': 'Foto de Perfil',
  'Please upload a clear photo of yourself': 'Suba una foto clara de usted',
  'Take / Upload Photo': 'Tomar / Subir Foto',
  'Skip for now — I\'ll add it at the front desk': 'Omitir por ahora — la agregaré en la recepción',
  'Add New Insurance': 'Agregar Nuevo Seguro',
  'Scan your Insurance Card': 'Escanee su Tarjeta de Seguro',
  'Take or upload clear photos of the front and back of your insurance card.': 'Tome o suba fotos claras del frente y del reverso de su tarjeta de seguro.',
  'Tap to scan insurance card': 'Toque para escanear la tarjeta de seguro',
  'Upload Front Image': 'Subir Imagen Frontal',
  'Upload Back Image': 'Subir Imagen Posterior',
  'Insurance Card Front': 'Frente de la Tarjeta de Seguro',
  'Insurance Card Back': 'Reverso de la Tarjeta de Seguro',
  'Insurance Image': 'Imagen del Seguro',
  'Skip for now - I don\'t have insurance': 'Omitir por ahora - No tengo seguro',
  'Select Coverage Type': 'Seleccionar Tipo de Cobertura',
  'Please Select Coverage Type': 'Seleccione el Tipo de Cobertura',
  'Primary Insurance is required. Please add Primary Insurance first.': 'El Seguro Primario es obligatorio. Agregue primero el Seguro Primario.',
  'Primary and Secondary Insurance are required. Please add them first.': 'Los Seguros Primario y Secundario son obligatorios. Agréguelos primero.',
  'Primary insurance is required. Add another Primary insurance first.': 'El seguro primario es obligatorio. Agregue primero otro seguro primario.',
  'Enter Payor Name': 'Ingrese el Nombre de la Aseguradora',
  'Select Payor': 'Seleccionar Aseguradora',
  'Please Select Payor': 'Seleccione la Aseguradora',
  'Select Insurance Plan': 'Seleccionar Plan de Seguro',
  'Select Plan': 'Seleccionar Plan',
  'Please Select Plan': 'Seleccione el Plan',
  'Enter Policy ID': 'Ingrese el ID de Póliza',
  'Please Enter Policy ID': 'Ingrese el ID de Póliza',
  'Policy ID cannot exceed 30 characters': 'El ID de Póliza no puede superar los 30 caracteres',
  'Enter Group ID': 'Ingrese el ID de Grupo',
  'Please Enter Group ID': 'Ingrese el ID de Grupo',
  'Group ID cannot exceed 30 characters': 'El ID de Grupo no puede superar los 30 caracteres',
  'Only letters and numbers are allowed': 'Solo se permiten letras y números',
  'Policy Holder Details': 'Datos del Titular de la Póliza',
  'Insured Person': 'Persona Asegurada',
  'Select Policy Holder': 'Seleccionar Titular de la Póliza',
  'Please Select Insured Person': 'Seleccione la Persona Asegurada',
  'Enter Insured First Name': 'Ingrese el Nombre del Asegurado',
  'Please Enter Insured First Name': 'Ingrese el Nombre del Asegurado',
  'Enter Insured Last Name': 'Ingrese el Apellido del Asegurado',
  'Please Enter Insured Last Name': 'Ingrese el Apellido del Asegurado',
  'SSN': 'Número de Seguro Social',
  'Enter SSN': 'Ingrese el Número de Seguro Social',
  'Primary Insurance': 'Seguro Primario',
  'Secondary Insurance': 'Seguro Secundario',
  'Tertiary Insurance': 'Seguro Terciario',
  'WorkersComp Insurance': 'Seguro de Compensación Laboral',
  'Other Insurance': 'Otro Seguro',
  'Patient has no insurance coverage (Self-pay)': 'El paciente no tiene cobertura de seguro (Pago por cuenta propia)',
  'Have a referral letter?': '¿Tiene una carta de referencia?',
  'Upload your referral letter here. We\'ll use it to identify your referral provider and the reason for your visit.': 'Suba aquí su carta de referencia. La usaremos para identificar a su proveedor de referencia y el motivo de su visita.',
  'Tap to upload your referral letter': 'Toque para subir su carta de referencia',
  'PDF, Word document, or Image': 'PDF, documento de Word o Imagen',
  'Skip — no referral': 'Omitir — no tengo referencia',
  'No Referral Letter Available': 'No hay Carta de Referencia',
  'This file type can\'t be previewed in the browser. Download it to view.': 'Este tipo de archivo no se puede ver en el navegador. Descárguelo para verlo.',
  'A little more about you': 'Un poco más sobre usted',
  'Answering these questions will help us serve you better': 'Responder estas preguntas nos ayudará a atenderle mejor',
  'Preferred language': 'Idioma preferido',
  'Select Preferred Language': 'Seleccionar Idioma Preferido',
  'Emergency Contact': 'Contacto de Emergencia',
  'Enter Emergency Contact Name': 'Ingrese el Nombre del Contacto de Emergencia',
  'Enter Emergency Mobile Number': 'Ingrese el Número de Móvil de Emergencia',
  'More Info': 'Más Información',
  'Select Ethnicity': 'Seleccionar Etnicidad',
  'Ethnicity is required': 'La etnicidad es obligatoria',
  'Select Sexual Orientation': 'Seleccionar Orientación Sexual',
  'Sexual Orientation is required': 'La orientación sexual es obligatoria',
  'No More About Data Available': 'No hay información adicional',
  'Use your insights to actively improve the quality of care we deliver.': 'Su información nos ayuda a mejorar la calidad de la atención que brindamos.',
  'Health Issues': 'Problemas de Salud',
  'I don’t have any medical conditions': 'No tengo ninguna condición médica',
  'Do you have any health conditions?': '¿Tiene alguna condición de salud?',
  'Type to search conditions': 'Escriba para buscar condiciones',
  'Select Health Conditions': 'Seleccionar Condiciones de Salud',
  'No Health Issues Data Available': 'No hay Problemas de Salud registrados',
  'Medications You Are Taking': 'Medicamentos que Toma',
  'Current Systemic Medications': 'Medicamentos Sistémicos Actuales',
  'Medications you take': 'Medicamentos que toma',
  'I don’t take any medications': 'No tomo ningún medicamento',
  'Which medications do you take regularly?': '¿Qué medicamentos toma regularmente?',
  'Please type here to add meds...': 'Escriba aquí para agregar medicamentos...',
  'Select Current Medication': 'Seleccionar Medicamento Actual',
  'No Current Medications Data Available': 'No hay Medicamentos Actuales registrados',
  'Daily Habits': 'Hábitos Diarios',
  'How often do you drink alcohol?': '¿Con qué frecuencia bebe alcohol?',
  'Do you smoke ?': '¿Fuma?',
  'Do you use recreational drugs or substances?': '¿Consume drogas o sustancias recreativas?',
  'Regularly': 'Regularmente',
  'Occasionally': 'Ocasionalmente',
  'Not anymore': 'Ya no',
  'Never': 'Nunca',
  'Socially': 'Socialmente',
  'Former using alcohol': 'Antes consumía alcohol',
  'Never smoked': 'Nunca he fumado',
  'Not anymore (I used to, but stopped)': 'Ya no (antes fumaba, pero lo dejé)',
  'Alcohol': 'Alcohol',
  'Drugs': 'Drogas',
  'No Daily Habits Data Available': 'No hay Hábitos Diarios registrados',
  'Allergies Information': 'Información de Alergias',
  'I don’t have any allergies': 'No tengo ninguna alergia',
  'Do you have any allergies we should know about?': '¿Tiene alguna alergia que debamos conocer?',
  'Select Allergy': 'Seleccionar Alergia',
  'Enter Allergies': 'Ingrese Alergias',
  'No Allergies Information Data Available': 'No hay Información de Alergias registrada',
  'Review & sign': 'Revisar y firmar',
  'Please read and sign to complete your check-in.': 'Lea y firme para completar su registro.',
  'Acknowledgment': 'Reconocimiento',
  'I have read and agree to the medical treatment consent from above': 'He leído y acepto el consentimiento de tratamiento médico anterior',
  'I acknowledge that I have received the Notice of Privacy Practices and consent to the use and disclosure of my health information as described': 'Reconozco que he recibido el Aviso de Prácticas de Privacidad y doy mi consentimiento para el uso y la divulgación de mi información de salud según lo descrito',
  'Digital Signature': 'Firma Digital',
  'Clear Signature': 'Borrar Firma',
  'Patient Signature': 'Firma del Paciente',
  'Parent / Guardian': 'Padre / Tutor',
  'Guardian Signature': 'Firma del Tutor',
  'Consent Status': 'Estado del Consentimiento',
  'Signed': 'Firmado',
  'Not Signed': 'No firmado',
  'Signatories': 'Firmantes',
  'No signatures yet.': 'Aún no hay firmas.',
  'Review your information': 'Revise su información',
  'Is everything correct? Feel free to modify any details before submitting.': '¿Está todo correcto? Puede modificar cualquier dato antes de enviar.',
  'Personal Information': 'Información Personal',
  'Review & Confirmation': 'Revisión y Confirmación',
  'I hereby confirm that the information I have provided in this form, including personal details, demographic information, insurance, medical history, medications, allergies, and consents, is true, accurate, and complete to the best of my knowledge.': 'Por la presente confirmo que la información que he proporcionado en este formulario, incluidos los datos personales, la información demográfica, el seguro, el historial médico, los medicamentos, las alergias y los consentimientos, es verdadera, exacta y completa según mi leal saber y entender.',
  'Messages and OTPs will be sent to your registered mobile number.': 'Los mensajes y códigos OTP se enviarán a su número de móvil registrado.',
  'Confirm Delete': 'Confirmar Eliminación',
  'Confirm Update': 'Confirmar Actualización',
  'Are you sure you want to delete this insurance image?': '¿Está seguro de que desea eliminar esta imagen del seguro?',
  'Are you sure you want to delete this Profile Picture?': '¿Está seguro de que desea eliminar esta Foto de Perfil?',
  'Are you sure you want to update the insurance?': '¿Está seguro de que desea actualizar el seguro?',
  'You Did It!': '¡Lo Logró!',
  'Thanks for filling that out — you’re officially in! We’ll take it from here.': '¡Gracias por completar el formulario, ya está registrado! Nosotros nos encargamos del resto.',
  'Click Here to Login Patient Portal': 'Haga clic aquí para iniciar sesión en el Portal del Paciente',

  // ── Patient Referral ──
  'Need help? Contact Support at': '¿Necesita ayuda? Comuníquese con Soporte al',
  '1. Referring Provider\'s Information': '1. Información del Proveedor que Refiere',
  'This ensures we can coordinate care and send follow-up reports.': 'Esto nos permite coordinar la atención y enviar informes de seguimiento.',
  'First Name is required.': 'El nombre es obligatorio.',
  'Last Name is required.': 'El apellido es obligatorio.',
  'NPI': 'NPI',
  'NPI is required.': 'El NPI es obligatorio.',
  'NPI must be digits only (up to 10).': 'El NPI solo debe contener dígitos (hasta 10).',
  'Email is required.': 'El correo electrónico es obligatorio.',
  'Please enter a valid email.': 'Ingrese un correo electrónico válido.',
  'Organization/Practice Name': 'Nombre de la Organización/Consultorio',
  '2. Patient Details': '2. Datos del Paciente',
  'Please provide the patient\'s information exactly as it appears on their health records.': 'Proporcione la información del paciente exactamente como aparece en sus registros de salud.',
  'Date of Birth is required.': 'La fecha de nacimiento es obligatoria.',
  'Phone number is required.': 'El número de teléfono es obligatorio.',
  'Gender is required.': 'El género es obligatorio.',
  'Zip Code': 'Código postal',
  'The patient has consented to be contacted.': 'El paciente ha dado su consentimiento para ser contactado.',
  '3. Referral Destination and Reason': '3. Destino y Motivo de la Referencia',
  'Select where you\'d like to send this referral and briefly explain the reason for the visit.': 'Seleccione a dónde desea enviar esta referencia y explique brevemente el motivo de la visita.',
  'Select Location': 'Seleccionar Ubicación',
  'Location is required.': 'La ubicación es obligatoria.',
  'Select Provider': 'Seleccionar Proveedor',
  'Provider is required.': 'El proveedor es obligatorio.',
  'Reason': 'Motivo',
  'Start typing here...': 'Empiece a escribir aquí...',
  'Reason is required.': 'El motivo es obligatorio.',
  'Notes to Provider': 'Notas para el Proveedor',
  'Urgency': 'Urgencia',
  'Normal': 'Normal',
  'Time-sensitive': 'Preferente',
  'Urgent': 'Urgente',
  'Urgency is required.': 'La urgencia es obligatoria.',
  'Submitting...': 'Enviando...',
  'Submit Referral': 'Enviar Referencia',
  'Referral Submitted Successfully!': '¡Referencia Enviada Correctamente!',
  'Thank you! Your referral has been sent to our team. We will contact you within 1-2 business days to schedule the consultation.': '¡Gracias! Su referencia ha sido enviada a nuestro equipo. Nos comunicaremos con usted en un plazo de 1 a 2 días hábiles para programar la consulta.',
  'Create another referral': 'Crear otra referencia',

  // ── Patient Payments ──
  'Pay Your Bill Online': 'Pague su Factura en Línea',
  'Settle your outstanding balance quickly and securely — from anywhere, at any time.': 'Pague su saldo pendiente de forma rápida y segura, desde cualquier lugar y en cualquier momento.',
  'How it works': 'Cómo funciona',
  'Enter your': 'Ingrese su',
  'name, MR number, email and phone': 'nombre, número de expediente, correo electrónico y teléfono',
  'to verify your identity.': 'para verificar su identidad.',
  'Enter the': 'Ingrese el',
  'amount your care team confirmed': 'monto confirmado por su equipo de atención',
  'during your call with us.': 'durante su llamada con nosotros.',
  'Complete your payment securely. A': 'Complete su pago de forma segura. Se le enviará un',
  'receipt will be emailed': 'recibo por correo electrónico',
  'to you instantly.': 'al instante.',
  'Need to discuss your bill?': '¿Necesita hablar sobre su factura?',
  'Our billing team is here to help.': 'Nuestro equipo de facturación está aquí para ayudarle.',
  'Call us at': 'Llámenos al',
  'Monday–Friday, 8 am – 5 pm': 'Lunes a viernes, 8 am – 5 pm',
  'Secure bill payment': 'Pago seguro de factura',
  'First name': 'Nombre',
  'Last name': 'Apellido',
  'First name is required.': 'El nombre es obligatorio.',
  'Last name is required.': 'El apellido es obligatorio.',
  'MR Number': 'Número de Expediente',
  '(located on invoice)': '(se encuentra en la factura)',
  'A valid email address is required.': 'Se requiere una dirección de correo electrónico válida.',
  'Phone': 'Teléfono',
  'Verify My Account': 'Verificar mi Cuenta',
  'Online payments are not available': 'Los pagos en línea no están disponibles',
  'This hospital does not accept online bill payments at this time. Please visit the hospital billing desk to pay your outstanding balance.': 'Este hospital no acepta pagos de facturas en línea en este momento. Visite el mostrador de facturación del hospital para pagar su saldo pendiente.',
  'For questions about your bill, call': 'Si tiene preguntas sobre su factura, llame al',
  'Verifying...': 'Verificando...',
  'Amount confirmed with your care team': 'Monto confirmado con su equipo de atención',
  'Please enter a valid amount greater than $0.00.': 'Ingrese un monto válido mayor a $0.00.',
  'Billing Address': 'Dirección de Facturación',
  'Street Address': 'Dirección',
  'ZIP': 'Código Postal',
  'Enter state': 'Ingrese el estado',
  'Enter your medical record number': 'Ingrese su número de expediente médico',
  'Your medical record number (MR Number) is printed on your medical receipt.': 'Su número de expediente médico (número MR) aparece en su recibo médico.',
  'MR Number is required.': 'El número MR es obligatorio.',
  'No billing address added': 'No se ha agregado una dirección de facturación',
  'Save & Close': 'Guardar y cerrar',
  'Unable to update billing address. Please try again.': 'No se pudo actualizar la dirección de facturación. Inténtelo de nuevo.',
  'Please save or close the billing address before paying.': 'Guarde o cierre la dirección de facturación antes de pagar.',
  'Patient Outstanding Balance': 'Saldo pendiente del paciente',
  'Payment allocation may take time.': 'La asignación del pago puede tardar un tiempo.',
  'Outstanding balance by organization': 'Saldo pendiente por organización',
  'Total': 'Total',
  'Enter street address': 'Ingrese la dirección',
  'Enter city': 'Ingrese la ciudad',
  'Enter ZIP code': 'Ingrese el código postal',
  'Continue to Payment': 'Continuar al Pago',
  'Payment Details': 'Detalles del Pago',
  'Payment Amount': 'Monto del Pago',
  'Please enter a valid amount.': 'Ingrese un monto válido.',
  'Payment Type': 'Tipo de Pago',
  'Credit Card': 'Tarjeta de Crédito',
  'Debit Card': 'Tarjeta de Débito',
  'Cardholder Name': 'Nombre del Titular de la Tarjeta',
  'Name on Card': 'Nombre en la Tarjeta',
  'Cardholder name is required.': 'El nombre del titular de la tarjeta es obligatorio.',
  'Loading secure payment fields...': 'Cargando campos de pago seguros...',
  'Card Number': 'Número de Tarjeta',
  'CVV': 'CVV',
  'Processing...': 'Procesando...',
  'Pay': 'Pagar',
  'Payment Successfully!': '¡Pago Exitoso!',
  'Thank you! A receipt has been sent to your email.': '¡Gracias! Se ha enviado un recibo a su correo electrónico.',
  'Thank you! Your payment was successfully processed': '¡Gracias! Su pago se procesó correctamente',
  'Amount Paid': 'Monto Pagado',
  'Receipt Number': 'Número de Recibo',
  'Transaction Number': 'Número de Transacción',
  'Loading secure card fields...': 'Cargando campos seguros de la tarjeta...',
  'Card details cannot be entered right now': 'No es posible ingresar los datos de la tarjeta en este momento',
  'Try again': 'Intentar de nuevo',
  'Minimum payment amount is $1.00.': 'El monto mínimo de pago es $1.00.',
  'Please enter the amount you would like to pay.': 'Ingrese el monto que desea pagar.',
  'The minimum payment amount is $1.00.': 'El monto mínimo de pago es $1.00.',
  'Card payment is not available right now because we could not connect to the payment provider for this hospital. Please try again, or contact the billing team for help.': 'El pago con tarjeta no está disponible en este momento porque no pudimos conectarnos con el proveedor de pagos de este hospital. Inténtelo de nuevo o comuníquese con el equipo de facturación para obtener ayuda.',
  'The secure card fields could not be loaded. This can happen with a slow or unstable internet connection, or when a browser extension (such as an ad blocker) blocks our payment provider. Please check your connection and try again.': 'No se pudieron cargar los campos seguros de la tarjeta. Esto puede ocurrir con una conexión a internet lenta o inestable, o cuando una extensión del navegador (como un bloqueador de anuncios) bloquea a nuestro proveedor de pagos. Verifique su conexión e inténtelo de nuevo.',
  'Date & Time': 'Fecha y Hora',
  'Generating Invoice...': 'Generando Factura...',
  'Download Invoice': 'Descargar Factura',
  'Powered by': 'Desarrollado por',

  // ── Patient Payments - messages ──
  'Verification failed. Please check your details.': 'La verificación falló. Revise sus datos.',
  'Verification failed. Please try again.': 'La verificación falló. Inténtelo de nuevo.',
  'No patient record found with the provided details. Please verify your information and try again.': 'No se encontró ningún registro de paciente con los datos proporcionados. Verifique su información e inténtelo de nuevo.',
  'Unable to load payment fields. Please close and try again.': 'No se pudieron cargar los campos de pago. Cierre e inténtelo de nuevo.',
  'Please enter valid card details before proceeding.': 'Ingrese datos de tarjeta válidos antes de continuar.',
  'We could not securely verify your card details. Please re-enter your card information and try again.': 'No pudimos verificar de forma segura los datos de su tarjeta. Vuelva a ingresar la información de su tarjeta e inténtelo de nuevo.',
  'Your card details could not be verified in time. Please re-enter your card information and try again.': 'No se pudieron verificar a tiempo los datos de su tarjeta. Vuelva a ingresar la información de su tarjeta e inténtelo de nuevo.',
  'We could not reach the payment processor, so your payment was not completed. Please try again in a moment.': 'No pudimos comunicarnos con el procesador de pagos, por lo que su pago no se completó. Inténtelo de nuevo en unos momentos.',
  'Your card was charged, but we ran into an issue recording your payment. Please contact our billing team before attempting to pay again so you are not charged twice.': 'Se realizó el cargo a su tarjeta, pero tuvimos un problema al registrar su pago. Comuníquese con nuestro equipo de facturación antes de volver a pagar para evitar un cargo doble.',
  'Your payment could not be completed. Please try again.': 'Su pago no se pudo completar. Inténtelo de nuevo.',
  'We were unable to process your payment due to a connection issue. Your card has not been charged — please try again.': 'No pudimos procesar su pago debido a un problema de conexión. No se realizó ningún cargo a su tarjeta; inténtelo de nuevo.',
  'Unable to download invoice. Please try again later.': 'No se pudo descargar la factura. Inténtelo de nuevo más tarde.',
  'Your card was declined. Please check your card details or try a different card.': 'Su tarjeta fue rechazada. Revise los datos de su tarjeta o use otra tarjeta.',
  'Your card was declined by your bank. Please contact your bank or try a different card.': 'Su banco rechazó la tarjeta. Comuníquese con su banco o use otra tarjeta.',
  'Your card has insufficient funds. Please try a different card.': 'Su tarjeta no tiene fondos suficientes. Use otra tarjeta.',
  'Your card is over its limit. Please try a different card.': 'Su tarjeta superó su límite. Use otra tarjeta.',
  'Your card was declined. Please verify your card details and try again.': 'Su tarjeta fue rechazada. Verifique los datos de su tarjeta e inténtelo de nuevo.',
  'The card number entered does not exist. Please double-check your card number.': 'El número de tarjeta ingresado no existe. Verifique el número de su tarjeta.',
  'This card number has been flagged as lost. Please use a different card.': 'Este número de tarjeta fue reportado como perdido. Use otra tarjeta.',
  'This card has expired. Please use a different card.': 'Esta tarjeta está vencida. Use otra tarjeta.',
  'The expiration date entered is invalid. Please check and try again.': 'La fecha de vencimiento ingresada no es válida. Revísela e inténtelo de nuevo.',
  'The CVV entered is invalid. Please check the security code on your card.': 'El CVV ingresado no es válido. Revise el código de seguridad de su tarjeta.',
  'This card type is not accepted. Please try a different card.': 'No se acepta este tipo de tarjeta. Use otra tarjeta.',
  'There was an issue verifying your card. Please try again or use a different card.': 'Hubo un problema al verificar su tarjeta. Inténtelo de nuevo o use otra tarjeta.',
  'This transaction exceeds the allowed amount. Please contact our billing team.': 'Esta transacción supera el monto permitido. Comuníquese con nuestro equipo de facturación.',
  'This transaction looks suspicious and was declined for your protection. Please contact your bank.': 'Esta transacción parece sospechosa y fue rechazada para su protección. Comuníquese con su banco.',
  'The security code (CVV) entered is invalid. Please check it and try again.': 'El código de seguridad (CVV) ingresado no es válido. Revíselo e inténtelo de nuevo.',
  'Your billing address could not be verified. Please check the address and ZIP you entered against the one on file with your bank.': 'No se pudo verificar su dirección de facturación. Compare la dirección y el código postal ingresados con los registrados en su banco.',
  'This looks like a duplicate transaction. Please contact our billing team before trying again so you are not charged twice.': 'Esta parece ser una transacción duplicada. Comuníquese con nuestro equipo de facturación antes de volver a intentarlo para evitar un cargo doble.',
  'The card details entered appear to be invalid. Please check them and try again.': 'Los datos de la tarjeta ingresados parecen no ser válidos. Revíselos e inténtelo de nuevo.',
  'Your payment could not be completed. Please check your card details and try again.': 'Su pago no se pudo completar. Revise los datos de su tarjeta e inténtelo de nuevo.',

  // ── Patient Onboarding - ID scan ──
  'ID details do not match': 'Los datos de la identificación no coinciden',
  'The name or date of birth on this ID does not match the patient details for this appointment.': 'El nombre o la fecha de nacimiento de esta identificación no coinciden con los datos del paciente de esta cita.',
  'Please scan the correct ID, or enter your details manually.': 'Escanee la identificación correcta o ingrese sus datos manualmente.',
  'Enter manually': 'Ingresar manualmente',
  'Rescan ID': 'Volver a escanear',

  // ── Portal Login ──
  'Experience Clarity': 'Experimente la claridad',
  // Org-configured login heading (PracticeName) – add an entry here for each org heading to translate
  'Welcome Patient portal page': 'Bienvenido a la página del portal del paciente',
  'Sign in to manage your visits and care details with EHNOTE.': 'Inicie sesión para administrar sus visitas y los detalles de su atención con EHNOTE.',
  'POWERED BY': 'DESARROLLADO POR',
  'Log in to your account': 'Inicie sesión en su cuenta',
  'Username': 'Nombre de usuario',
  'Enter Username': 'Ingrese su nombre de usuario',
  'Username is required': 'El nombre de usuario es obligatorio',
  'Username is required.': 'El nombre de usuario es obligatorio.',
  'No record found for the entered username.': 'No se encontró ningún registro para el nombre de usuario ingresado.',
  'Credentials are not valid.': 'Las credenciales no son válidas.',
  'Password': 'Contraseña',
  'Login with OTP': 'Iniciar sesión con OTP',
  'Enter password': 'Ingrese la contraseña',
  'Password is required': 'La contraseña es obligatoria',
  'Password is required.': 'La contraseña es obligatoria.',
  'Forgot Password?': '¿Olvidó su contraseña?',
  'We couldn\'t find an email or mobile number linked to your account. Please contact your administrator for assistance.': 'No encontramos un correo electrónico ni un número de celular vinculado a su cuenta. Comuníquese con su administrador para obtener ayuda.',
  'Don’t have an account?': '¿No tiene una cuenta?',
  'Sign up': 'Regístrese',
  'Privacy Policy': 'Política de privacidad',
  'and': 'y',
  'Terms of Services': 'Términos de servicio',
  'Choose a way to confirm its you': 'Elija cómo confirmar que es usted',
  'These are your available confirmation methods.': 'Estos son sus métodos de confirmación disponibles.',
  'We\'ll send a code to your email': 'Le enviaremos un código a su correo electrónico',
  'Mobile': 'Celular',
  'We\'ll send a code to your mobile': 'Le enviaremos un código a su celular',
  'Request OTP': 'Solicitar OTP',
  'Please Enter OTP': 'Ingrese el código OTP',
  'Enter the code we sent to your mobile/email': 'Ingrese el código que enviamos a su celular/correo electrónico',
  'OTP Expired': 'El código OTP expiró',
  'OTP Expires in': 'El código OTP expira en',
  'Resend OTP': 'Reenviar OTP',
  'The OTP you entered is incorrect. Please check the code and try again.': 'El código OTP que ingresó es incorrecto. Verifique el código e inténtelo de nuevo.',
  'OTP verification failed. Please try again.': 'La verificación del código OTP falló. Inténtelo de nuevo.',
  'Verify': 'Verificar',
  'Enter the mobile number you’ve registered with us': 'Ingrese el número de celular que registró con nosotros',
  'We’ll send a code to the provided registered number': 'Le enviaremos un código al número registrado',
  'Please enter valid mobile number': 'Ingrese un número de celular válido',
  'No patient is registered under this mobile number.': 'No hay ningún paciente registrado con este número de celular.',
  'Already have an account?': '¿Ya tiene una cuenta?',
  'Login here': 'Inicie sesión aquí',
  'Looks like this contact is shared by multiple patients.': 'Parece que varios pacientes comparten este contacto.',
  'Continue': 'Continuar',
  'Back to Login': 'Volver al inicio de sesión',
  'Your details': 'Sus datos',
  'Please provide necessary details and continue to create account': 'Proporcione los datos necesarios y continúe para crear su cuenta',
  'First name does not match selected patient.': 'El nombre no coincide con el paciente seleccionado.',
  'Last name does not match selected patient.': 'El apellido no coincide con el paciente seleccionado.',
  'Male': 'Masculino',
  'Female': 'Femenino',
  'Prefer not to tell': 'Prefiero no decirlo',
  'Unknown': 'Desconocido',
  'Date of birth does not match.': 'La fecha de nacimiento no coincide.',
  'Number': 'Número',
  'Mobile number does not match selected patient.': 'El número de celular no coincide con el paciente seleccionado.',
  'Verify & Continue': 'Verificar y continuar',
  'Choose your credentials': 'Elija sus credenciales',
  'Enter your email address': 'Ingrese su correo electrónico',
  'Choose any username': 'Elija un nombre de usuario',
  'Username already exists.': 'El nombre de usuario ya existe.',
  'Something went wrong. Please try again.': 'Algo salió mal. Inténtelo de nuevo.',
  'Use my email address as my username': 'Usar mi correo electrónico como nombre de usuario',
  'Create a strong password': 'Cree una contraseña segura',
  'Choose a password': 'Elija una contraseña',
  'Confirm Password': 'Confirmar contraseña',
  'Confirm your password': 'Confirme su contraseña',
  'Confirm password is required.': 'La confirmación de la contraseña es obligatoria.',
  'Password and Confirm Password do not match.': 'La contraseña y la confirmación no coinciden.',
  'Create my account': 'Crear mi cuenta',
  'Update Password': 'Actualizar contraseña',
  'Confirm it\'s you': 'Confirme que es usted',
  'Enter your username and date of birth to confirm it\'s your account.': 'Ingrese su nombre de usuario y fecha de nacimiento para confirmar que es su cuenta.',
  'Date of birth is required': 'La fecha de nacimiento es obligatoria',
  'Patient credential mismatch.': 'Las credenciales del paciente no coinciden.',
  'Not sure about your username?': '¿No recuerda su nombre de usuario?',
  'Contact our practice': 'Comuníquese con nuestro consultorio',
  'for assistance.': 'para obtener ayuda.',
  'Account already exists': 'La cuenta ya existe',
  'We found an account linked to': 'Encontramos una cuenta vinculada a',
  'Click Continue to login and proceed.': 'Haga clic en Continuar para iniciar sesión.',
  'We found an account linked to {name}. Click Continue to login and proceed.': 'Encontramos una cuenta vinculada a {name}. Haga clic en Continuar para iniciar sesión.',
  'Continue to Login': 'Continuar al inicio de sesión',
  'move to confirm its you': 'confirmar que es usted',
  'User Name': 'Nombre de usuario',
  'Choose a different patient': 'Elegir otro paciente',

  // ── Patient Onboarding Login ──
  'Welcome!': '¡Bienvenido!',
  'Text Size': 'Tamaño del texto',
  'Large': 'Grande',
  'Small': 'Pequeño',
  'We will send you an OTP to verify your mobile number': 'Le enviaremos un código OTP para verificar su número de móvil',
  'Enter registered mobile number': 'Ingrese el número de móvil registrado',
  'Send OTP': 'Enviar OTP',
  'Powered By': 'Desarrollado por',
  'Enter OTP': 'Ingrese el código OTP',
  'We have sent a 4-digit code to': 'Hemos enviado un código de 4 dígitos a',
  'Enter valid OTP': 'Ingrese un código OTP válido',
  'Resend OTP in': 'Reenviar OTP en',

  // ── Book Appointment ──
  'Back to your details': 'Volver a sus datos',
  'Need help?': '¿Necesita ayuda?',
  'Step {current} of {total}': 'Paso {current} de {total}',
  'Appointment': 'Cita',
  'Change': 'Cambiar',
  'Have you visited us before?': '¿Nos ha visitado antes?',
  'New Patient': 'Paciente Nuevo',
  'Existing Patient': 'Paciente Existente',
  'Book an appointment': 'Programar una cita',
  'Clinic': 'Clínica',
  'Search location': 'Buscar ubicación',
  'No clinics match "{search}".': 'Ninguna clínica coincide con "{search}".',
  'New patient': 'Paciente nuevo',
  'Returning patient': 'Paciente recurrente',
  'Send Appointment Details and Updates via SMS': 'Enviar detalles y actualizaciones de la cita por SMS',
  'Choose your appointment': 'Elija su cita',
  'Visit': 'Consulta',
  'Self pay': 'Pago por cuenta propia',
  'Reason for visit': 'Motivo de la consulta',
  'Select a reason': 'Seleccione un motivo',
  'No items found': 'No se encontraron resultados',
  'Loading...': 'Cargando...',
  'Insurance payor': 'Aseguradora',
  'Search your insurance': 'Busque su seguro',
  'Select a provider': 'Seleccione un proveedor',
  'Loading providers...': 'Cargando proveedores...',
  'Date and time': 'Fecha y hora',
  'Choose a reason for your visit to see providers and open times.': 'Elija el motivo de su consulta para ver los proveedores y los horarios disponibles.',
  'Select a provider to see available dates and times.': 'Seleccione un proveedor para ver las fechas y horas disponibles.',
  'Select one time slot': 'Seleccione un horario',
  'No slots available for today': 'No hay horarios disponibles para hoy',
  'No slots available for this date': 'No hay horarios disponibles para esta fecha',
  'Don\'t worry, we\'ll help you find another time. Join the waitlist and we\'ll let you know if a time opens, or ask us to call you. Need help? Call {phone}.': 'No se preocupe, le ayudaremos a encontrar otro horario. Únase a la lista de espera y le avisaremos si se libera un horario, o pídanos que le llamemos. ¿Necesita ayuda? Llame al {phone}.',
  'Searching...': 'Buscando...',
  'See Next Available Slot': 'Ver el Próximo Horario Disponible',
  'No available slots found in the next 30 days. Please try again later or contact support.': 'No se encontraron horarios disponibles en los próximos 30 días. Inténtelo de nuevo más tarde o comuníquese con soporte.',
  'Request a Callback': 'Solicitar una Llamada',
  'No time selected': 'Ningún horario seleccionado',
  'Pick a date and time above': 'Elija una fecha y hora arriba',
  'Choose a reason for your visit': 'Elija el motivo de su consulta',
  'Booking...': 'Programando...',
  'Book appointment': 'Programar cita',
  'You already have an appointment booked on this date with the selected provider. Please choose another date or contact support for assistance.': 'Ya tiene una cita programada en esta fecha con el proveedor seleccionado. Elija otra fecha o comuníquese con soporte para obtener ayuda.',
  'Appointment confirmed': 'Cita confirmada',
  'Your appointment is confirmed!': '¡Su cita está confirmada!',
  'Hi {name}, a confirmation is on its way.': 'Hola {name}, le enviaremos una confirmación en breve.',
  'When': 'Cuándo',
  'Get Directions': 'Cómo Llegar',
  'Need to cancel or reschedule? Call': '¿Necesita cancelar o reprogramar? Llame al',
  'Book another appointment': 'Programar otra cita',
  'You\'re on the waitlist!': '¡Está en la lista de espera!',
  'We\'ll be in touch within a few hours if a spot becomes available. We\'ll do our best to find a time for you.': 'Nos comunicaremos con usted en unas horas si se libera un espacio. Haremos todo lo posible para encontrarle un horario.',
  'Go back to home': 'Volver al inicio',
  'We\'ll call you back!': '¡Le devolveremos la llamada!',
  'Our team will call you shortly to help you book an appointment over the phone.': 'Nuestro equipo le llamará en breve para ayudarle a programar una cita por teléfono.',

  // ── Book Appointment - your details (login / registration) ──
  'Verification': 'Verificación',
  'Please enter your email or mobile number to begin': 'Ingrese su correo electrónico o número de móvil para comenzar',
  'Please enter a valid mobile number.': 'Ingrese un número de móvil válido.',
  'Enter the 4-digit OTP sent to': 'Ingrese el código OTP de 4 dígitos enviado a',
  'This OTP has expired. Please request a new OTP to continue.': 'Este código OTP ha vencido. Solicite un nuevo código OTP para continuar.',
  'OTP expires in': 'El código OTP vence en',
  'Verify and Proceed': 'Verificar y Continuar',
  'Who is this appointment for?': '¿Para quién es esta cita?',
  'Please choose the patient for this appointment.': 'Elija el paciente para esta cita.',
  'Patient photo': 'Foto del paciente',
  'Default profile': 'Perfil predeterminado',
  'Note:': 'Nota:',
  'Un-check the selected patient to add a new patient.': 'Desmarque el paciente seleccionado para agregar un paciente nuevo.',
  'Add New Patient': 'Agregar Paciente Nuevo',
  'This information helps us confirm your identity and ensure accurate records.': 'Esta información nos ayuda a confirmar su identidad y mantener registros precisos.',
  'Prefer Not To Tell': 'Prefiero no decirlo',
  'Please verify your mobile number using OTP before continuing.': 'Verifique su número de móvil con el código OTP antes de continuar.',
  'Verification Code': 'Código de verificación',
  'Change Number': 'Cambiar número',
  'Mobile number verified successfully': 'Número de móvil verificado correctamente',
  'Patient Already Registered': 'Paciente ya Registrado',
  'A patient with the same First Name, Last Name, Date of Birth, and Mobile Number already exists.': 'Ya existe un paciente con el mismo nombre, apellido, fecha de nacimiento y número de móvil.',
  'Name:': 'Nombre:',
  'DOB:': 'Fecha de nac.:',
  'Patient ID:': 'ID del paciente:',
  'Open Existing Patient': 'Abrir Paciente Existente',

  // ── Date of birth field (datepicker-manual-and-cal-selection directive) ──
  'Invalid month. Month must be between 1 and 12': 'Mes no válido. El mes debe estar entre 1 y 12',
  'You are not allowed to remove \'0\' from month': 'No se permite quitar el \'0\' del mes',
  'Invalid date format. ‘-’ is required between month, day, and year.': 'Formato de fecha no válido. Se requiere ‘-’ entre el mes, el día y el año.',
  'Invalid month. Only two digits are allowed for the month.': 'Mes no válido. Solo se permiten dos dígitos para el mes.',
  'Invalid day. Only two digits are allowed for the day.': 'Día no válido. Solo se permiten dos dígitos para el día.',
  'Invalid month format. Leading zero is required for single-digit month.': 'Formato de mes no válido. Los meses de un dígito deben llevar un cero inicial.',
  'Invalid day format. Leading zero is required for single-digit day.': 'Formato de día no válido. Los días de un dígito deben llevar un cero inicial.',
  'Invalid year. Year cannot be earlier than 1800.': 'Año no válido. El año no puede ser anterior a 1800.',
  'The entered year is not a leap year.': 'El año ingresado no es bisiesto.',
  'Future dates are not allowed. Please select a valid date.': 'No se permiten fechas futuras. Seleccione una fecha válida.',
  'Invalid date. The entered year is not a leap year': 'Fecha no válida. El año ingresado no es bisiesto',
  'Invalid date format. Please enter the date in MM-DD-YYYY format': 'Formato de fecha no válido. Ingrese la fecha en formato MM-DD-AAAA',
};